import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewSingleMacrofamily = (id) => {
  return useQuery({
    queryKey: ['viewMacrofamilyDetails', id],
    enabled: !!id, 
    queryFn: async ({ queryKey }) => {
      const macrofamilyId = queryKey[1];   
      const res = await api.get(`/macros/show/${macrofamilyId}`);
      return res.data;
    },
  });
};